import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, inject } from '@angular/core';

import { map } from 'rxjs/operators';

import { Store } from '@ngxs/store';

import { PATHS_DICT, ROUTES_PREFIX } from '../../../auth/auth.routes';
import { UserLogOut } from '../../state/app.actions';
import { AppState } from '../../state/app.state';

@Component({
  selector: 'sh-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrl: './main-nav.component.scss',
  standalone: false
})
export class MainNavComponent {
  readonly #breakpointObserver = inject(BreakpointObserver);
  readonly #store = inject(Store);

  loggedUser$ = this.#store.select(AppState.getUser);
  isHandset$ = this.#breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  onLogoutButtonClick(): void {
    this.#store.dispatch(
      new UserLogOut({
        logoutParams: {
          returnTo: this.#getReturnTo()
        }
      })
    );
  }

  #getReturnTo(): string {
    const url = new URL(`${ROUTES_PREFIX}/${PATHS_DICT.LOGIN}`, window.location.origin);

    url.searchParams.append('target', window.location.pathname);

    return url.href;
  }
}
